import { h } from 'preact'

import SmartImg, { SmartImgSettingsProvider } from '../atom/nbb-smart-img'
import withFont, { FONT_ROBOTO_CONDENSED } from '../util/Font'

import Gallery from './gallery'

const IMAGE_PROPS = {
  placeholder: true,
  defaultSize: 160,
  maxSize: 600,
  sizes: '(min-width: 1920px) 300px, (min-width: 1200px) 15vw, (min-width: 1200px) 32vw, 45vw',
}

const StyledGallery = (props) => (
  <SmartImgSettingsProvider {...IMAGE_PROPS}>
    <Gallery
      {...props}
      alignBottom
      ImgElement={SmartImg}
    />
  </SmartImgSettingsProvider>
)

export default withFont(StyledGallery, FONT_ROBOTO_CONDENSED, 'NBBGallery')
